<template>
  <div class="relative add-page">
    <div>
      <el-form :model="form" ref="form" label-width="120px" :hide-required-asterisk="true">
        <!--        <el-form :model="form" ref="form" label-width="120px" :hide-required-asterisk="true" :disabled="form.evaluateStatus>1">-->
        <div @keyup.enter.stop="save()">
          <!--          <el-form-item label="评分方式" prop="dimensionType" :rules="[{required: true, message: '请选择', trigger: 'change'}]" style="margin-top: 10px;">-->
          <!--            <el-radio-group v-model="form.dimensionType">-->
          <!--              <el-radio v-for="(item,key) in $enums.dimensionType" :key="key" :label="Number(key)">{{item}}</el-radio>-->
          <!--            </el-radio-group>-->
          <!--          </el-form-item>-->
          <div v-if="form.dimensionType==1" class="border" style="margin: 0 50px;">
            <div v-for="(item,i) in form.dimensionList" :key="'dimensionList'+i">
              <div v-if="form.evaluateStatus<2" class="absolute right" style="right: 160px;width: 60px;z-index: 3;">
                <i v-if="i==form.dimensionList.length-1" class="icon icon_add-circle pointer" @click="addDimension(i)" style="font-size: 30px;"></i>
                <i v-if="form.dimensionList.length>1" class="icon icon_minus-circle pointer" @click="delDimension(i)" style="font-size: 30px;"></i>
              </div>
              <el-form-item :label="i==0?'综合评分内容项':''" :prop="'dimensionList.'+i+'.itemName'" :rules="[$validate.string(4)]">
                <el-input v-model="form.dimensionList[i].itemName" :maxlength="4" placeholder="请输入" style="width: 200px;"></el-input>
              </el-form-item>
            </div>
          </div>
          <el-form-item label="评分设置" prop="itemEvaluateType" :rules="[{required: true, message: '请选择', trigger: 'change'}]" style="margin-top: 10px;">
            <el-radio-group v-model="form.itemEvaluateType">
              <el-radio v-for="(item,key) in $enums.evaluateType" :key="key" :label="Number(key)">{{item}}</el-radio>
            </el-radio-group>
          </el-form-item>
          <div v-if="form.itemEvaluateType==0" class="border" style="margin: 0 50px;">
            <div v-for="(item,i) in form.itemLevelList" :key="'itemLevelList'+i">
              <div v-if="form.evaluateStatus<2" class="absolute right" style="right: 160px;width: 60px;z-index: 3;">
                <i v-if="i==form.itemLevelList.length-1" class="icon icon_add-circle pointer" @click="addSubjectLevel(i)" style="font-size: 30px;"></i>
                <i v-if="form.itemLevelList.length>1" class="icon icon_minus-circle pointer" @click="delSubjectLevel(i)" style="font-size: 30px;"></i>
              </div>
              <el-form-item :label="i==0?'自定义设置':''" :prop="'itemLevelList.'+i+'.itemName'" :rules="[$validate.string(4)]">
                <el-input v-model="form.itemLevelList[i].itemName" :maxlength="4" placeholder="请输入" style="width: 100px;"></el-input>
              </el-form-item>
            </div>
          </div>
          <template v-else>
            <el-form-item class="inline-block" label="分值设置" prop="lowerScore" :rules="[$validate.integer(false)]">
              <span style="color: #666666;">最低分 </span>
              <el-input class="inline-block" style="width: 100px;" v-model="form.lowerScore" :maxlength="20" @input="e=>form.lowerScore=Tool.checkNumber(e,Number(form.upperScore)||1000)"
                        placeholder="请输入"></el-input>
            </el-form-item>
            <el-form-item class="inline-block" style="margin-left: 10px;" label="" label-width="0px" prop="upperScore" :rules="[$validate.integer(false)]">
              <span style="color: #666666;">最高分 </span>
              <el-input class="inline-block" style="width: 100px;" v-model="form.upperScore" :maxlength="20" @input="e=>form.upperScore=Tool.checkNumber(e,1000)" placeholder="请输入"></el-input>
            </el-form-item>
          </template>
          <el-form-item label="评语设置" prop="isItemRemark" :rules="[{required: true, message: '请选择', trigger: 'change'}]" style="margin-top: 10px;">
            <el-radio-group v-model="form.isItemRemark">
              <el-radio v-for="(item,key) in $enums.boolean" :key="key" :label="Number(key)">{{item}}</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="考试结果方式" prop="evaluateType" :rules="[{required: true, message: '请选择', trigger: 'change'}]" style="margin-top: 10px;">
            <el-radio-group v-model="form.evaluateType">
              <el-radio v-for="(item,key) in $enums.evaluateType" :key="key" :label="Number(key)">{{item}}</el-radio>
            </el-radio-group>
          </el-form-item>
          <div v-if="form.evaluateType==0" class="border" style="margin: 0 50px;">
            <div v-for="(item,i) in form.evaluateLevelList" :key="'evaluateLevelList'+i">
              <div v-if="form.evaluateStatus<2" class="absolute right" style="right: 160px;width: 60px;z-index: 3;">
                <i v-if="i==form.evaluateLevelList.length-1" class="icon icon_add-circle pointer" @click="addEvaluateLevel(i)" style="font-size: 30px;"></i>
                <i v-if="form.evaluateLevelList.length>1" class="icon icon_minus-circle pointer" @click="delEvaluateLevel(i)" style="font-size: 30px;"></i>
              </div>
              <el-form-item :label="i==0?'自定义设置':''" :prop="'evaluateLevelList.'+i+'.itemName'" :rules="[$validate.string(4)]">
                <el-input v-model="form.evaluateLevelList[i].itemName" :maxlength="4" placeholder="请输入" style="width: 100px;"></el-input>
              </el-form-item>
            </div>
          </div>
          <template v-else>
            <el-form-item class="inline-block" label="分值设置" prop="resultLowerScore" :rules="[$validate.integer(false)]">
              <span style="color: #666666;">最低分 </span>
              <el-input class="inline-block" style="width: 100px;" v-model="form.resultLowerScore" :maxlength="20"
                        @input="e=>form.resultLowerScore=Tool.checkNumber(e,Number(form.resultUpperScore)||1000)" placeholder="请输入"></el-input>
            </el-form-item>
            <el-form-item class="inline-block" style="margin-left: 10px;" label="" label-width="0px" prop="resultUpperScore" :rules="[$validate.integer(false)]">
              <span style="color: #666666;">最高分 </span>
              <el-input class="inline-block" style="width: 100px;" v-model="form.resultUpperScore" :maxlength="20"
                        @input="e=>form.resultUpperScore=Tool.checkNumber(e,1000)" placeholder="请输入"></el-input>
            </el-form-item>
          </template>
          <el-form-item label="结果评语设置" prop="isEvaluateRemark" :rules="[{required: true, message: '请选择', trigger: 'change'}]" style="margin-top: 10px;">
            <el-radio-group v-model="form.isEvaluateRemark">
              <el-radio v-for="(item,key) in $enums.boolean" :key="key" :label="Number(key)">{{item}}</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="考官签名设置" prop="isSign" :rules="[{required: true, message: '请选择', trigger: 'change'}]" style="margin-top: 10px;">
            <el-radio-group v-model="form.isSign">
              <el-radio v-for="(item,key) in $enums.boolean" :key="key" :label="Number(key)">{{item}}</el-radio>
            </el-radio-group>
          </el-form-item>
        </div>
      </el-form>
    </div>
    <div class="text-right add-bottom fixed">
      <el-button size="medium" @click="$router.push({path:'./setting',query:$route.query})">取消</el-button>
      <el-button size="medium" type="primary" @click="save()" style="margin-right: 0px;">确定</el-button>
      <!--      <el-button v-if="form.evaluateStatus<2" size="medium" type="primary" @click="save()" style="margin-right: 0px;">确定</el-button>-->
    </div>
  </div>
</template>
<script>
export default {
  name: 'edit',
  components: {},
  props: ['row'],
  data () {
    return {
      form: {
        dimensionType: 0,
        itemEvaluateType: 0,
        evaluateType: 0,
        dimensionList: [{ itemName: '' }],
        itemLevelList: [{ itemName: '' }],
        evaluateLevelList: [{ itemName: '' }],
        isItemRemark: 0,
        isEvaluateRemark: 0,
        isSign: 0,
        evaluateStatus: 0
      }
    }
  },
  async created () {
    await this.initForm()
  },
  async mounted () {
  },
  async beforeDestroy () {
  },
  computed: {},
  watch: {},
  methods: {
    async addDimension (i) {
      let isOK = await this.Tool.checkForm(this.$refs['form'], [`dimensionList.${i}.itemName`])
      if (isOK) {
        this.form.dimensionList.splice(Number(i) + 1, 0, { itemName: '', itemType: 0 })
      }
    },
    delDimension (i) {
      this.form.dimensionList.splice(i, 1)
    },
    async addSubjectLevel (i) {
      let isOK = await this.Tool.checkForm(this.$refs['form'], [`itemLevelList.${i}.itemName`])
      if (isOK) {
        this.form.itemLevelList.splice(Number(i) + 1, 0, { itemName: '', itemType: 1 })
      }
    },
    delSubjectLevel (i) {
      this.form.itemLevelList.splice(i, 1)
    },
    async addEvaluateLevel (i) {
      let isOK = await this.Tool.checkForm(this.$refs['form'], [`evaluateLevelList.${i}.itemName`])
      if (isOK) {
        this.form.evaluateLevelList.splice(Number(i) + 1, 0, { itemName: '', itemType: 2 })
      }
    },
    delEvaluateLevel (i) {
      this.form.evaluateLevelList.splice(i, 1)
    },
    async initForm () {
      if (this.$route.query.settingsId) {
        let info = await this.$HTTP.GradeSetting.getInfo(this.$route.query.settingsId)
        info.dimensionList = []
        info.itemLevelList = []
        info.evaluateLevelList = []
        for (let i in info.itemList) {
          let item = info.itemList[i]
          if (Number(item.itemType) === 0) {
            info.dimensionList.push(item)
          } else if (Number(item.itemType) === 1) {
            info.itemLevelList.push(item)
          } else if (Number(item.itemType) === 2) {
            info.evaluateLevelList.push(item)
          }
        }
        if (this.Tool.isNull(info.dimensionList)) {
          info.dimensionList.push({ itemName: '', itemType: 0 })
        }
        if (this.Tool.isNull(info.itemLevelList)) {
          info.itemLevelList.push({ itemName: '', itemType: 1 })
        }
        if (this.Tool.isNull(info.evaluateLevelList)) {
          info.evaluateLevelList.push({ itemName: '', itemType: 2 })
        }
        this.form = info
      } else {
        this.form = {
          batchId: this.$route.query.batchId,
          dimensionType: 0,
          itemEvaluateType: 0,
          evaluateType: 0,
          dimensionList: [{ itemName: '', itemType: 0 }],
          itemLevelList: [{ itemName: '', itemType: 1 }],
          evaluateLevelList: [{ itemName: '', itemType: 2 }],
          isItemRemark: 0,
          isEvaluateRemark: 0,
          isSign: 0,
          evaluateStatus: 0,
          lowerScore: null,
          upperScore: null,
          resultLowerScore: null,
          resultUpperScore: null
        }
      }
      this.$forceUpdate()
      this.$nextTick(() => {
        if (this.$refs['form']) {
          this.$refs['form'].clearValidate()
        }
      })
    },
    async save () {
      let isOK = await this.Tool.checkForm(this.$refs['form'])
      if (isOK) {
        let info = JSON.parse(JSON.stringify(this.form))
        let itemList = []
        if (Number(info.dimensionType) === 1) {
          itemList.push(...info.dimensionList)
        }
        if (Number(info.itemEvaluateType) === 0) {
          itemList.push(...info.itemLevelList)
          info.lowerScore = null
          info.upperScore = null
        } else {
          if (Number(info.lowerScore) > Number(info.upperScore)) {
            throw new Error('最低分不得高于最高分')
          }
        }
        if (Number(info.evaluateType) === 0) {
          itemList.push(...info.evaluateLevelList)
          info.resultLowerScore = null
          info.resultUpperScore = null
        } else {
          if (Number(info.resultLowerScore) > Number(info.resultUpperScore)) {
            throw new Error('最低分不得高于最高分')
          }
        }
        info.itemList = itemList
        info.dimensionType = 0
        if (info.settingsId) {
          await this.$HTTP.GradeSetting.edit(info)
        } else {
          await this.$HTTP.GradeSetting.add(info)
        }
        this.$message({ type: 'success', message: '保存成功' })
        this.$router.replace({ path: './setting', query: this.$route.query })
      }
    }
  }
}
</script>
